var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "white",
    stroke: "#3F46AD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1612 20.1123L11.4097 8.81819L13.1264 8.81819L13.3748 20.1123L11.1612 20.1123ZM12.1777 4.23277C12.5692 4.23277 12.9005 4.3683 13.1715 4.63936C13.4426 4.91042 13.5781 5.24171 13.5781 5.63324C13.5781 6.02477 13.4426 6.35607 13.1715 6.62713C12.9005 6.89819 12.5692 7.03371 12.1777 7.03371C11.8012 7.03371 11.4849 6.89819 11.2289 6.62713C10.9579 6.35607 10.8224 6.02477 10.8224 5.63324C10.8224 5.24171 10.9579 4.91042 11.2289 4.63936C11.4849 4.3683 11.8012 4.23277 12.1777 4.23277Z",
    fill: "#3F46AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.43e638c952825620ad201af11d1fab31.svg";
export { ForwardRef as ReactComponent };